exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mounted-flag[data-v-719ad731] {\n  display: none;\n}\n", ""]);

// exports
